/**
 * @constant
 */
const USG_STATE = {
    NEGATIVE: 0,
    POSITIVE: 1,
    REPEAT: 2,
    REPEAT_NEGATIVE: 3,
    REPEAT_POSITIVE: 4
};


module.exports = {
    USG_STATE
};
